import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCg-gcUvvPPIVlF9I-eXcoF3bd4xoVVbLE',
  authDomain: 'cacafigurinhas.firebaseapp.com',
  projectId: 'cacafigurinhas',
  storageBucket: 'cacafigurinhas.firebasestorage.app',
  messagingSenderId: '193781453804',
  appId: '1:193781453804:web:a6fc1b2cddcca6a89d26c9',
  measurementId: 'G-L06W1C1ZTY',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
